<template>
    <div class="form-field form-field--select" :class="{'form-field--error': hasError, 'form-field--no-label': !label}">
        <label :for="name" class="form-field__label" v-if="label">{{label}}</label>
        <div class="form-field__input-container">
            <select :name="name" :id="name" class="form-field__input form-field__input--select" required v-validate="'required'" v-model="selection">
                <option :disabled="!allowEmpty" value="">{{ selectLabel }}</option>
                <option :value="option.value + ''" v-for="option in options" :key="option.value">{{option.label}}</option>
            </select>
            <div class="form-field__icon icon"></div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            label: String,
            selectLabel: String,
            name: String,
            options: Array,
            value: String,
            allowEmpty: {
                default: false,
                type: Boolean
            }
        },
        data() {
            return {
                hasError: false,
                selection: '',
            }
        },
        watch: {
            selection: function(selection) {
                if (selection !== '') {
                    this.hasError = false;
                }

                this.$emit('input', selection);
            },
            value: function(value) {
                this.selection = value ? value : '';
            }
        },
        methods: {
            validate: function() {
                return this.$validator.validate().then((result) => {
                    this.hasError = !result;

                    return result;
                });
            }
        },
        mounted() {
            this.selection = this.value ? this.value : '';
        }
    }
</script>